module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiBmaWxsPSIjNzg4QTlGIiBmaWxsLW9wYWNpdHk9Ii4wNCIgcng9IjExIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzc3OEI5RiIgZD0iTTEzLjU3MiA3LjQ4OEwxMC40IDEwLjQ0NmwyLjk1OCAzLjE3Mi0uOTY1LjktMy44NTgtNC4xMzcgNC4xMzctMy44NTh6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/controls/calendar-previous.svg
// module id = ./src/assets/controls/calendar-previous.svg
// module chunks = 0